

import React from 'react';
import './Legal.css';

const Privacy = () => {
  return (
    <div className="legal-page">
      <section className="legal-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>Last updated: February 2024</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          <div className="legal-text">
            <h2>1. Information We Collect</h2>
            <p>At MOJ, we collect the following types of information to provide and improve our services:</p>
            
            <h3>Personal Information</h3>
            <ul>
              <li>Name, email address, and phone number</li>
              <li>CNIC/NICOP details for verification</li>
              <li>Payment information (processed securely through third-party providers)</li>
              <li>Profile picture (optional)</li>
            </ul>

            <h3>Location Data</h3>
            <ul>
              <li>Real-time GPS location during rides</li>
              <li>Pickup and drop-off locations</li>
              <li>Route history</li>
            </ul>

            <h3>Device Information</h3>
            <ul>
              <li>Device type and operating system</li>
              <li>IP address and mobile network</li>
              <li>App usage statistics and crash reports</li>
            </ul>

            <h2>2. How We Use Your Data</h2>
            <ul>
              <li>To provide ride-sharing services and customer support</li>
              <li>To ensure safety and security of passengers and drivers</li>
              <li>To process payments and generate invoices</li>
              <li>To improve our services and develop new features</li>
              <li>To comply with legal obligations</li>
            </ul>

            <h2>3. Data Sharing</h2>
            <p>We do not sell your personal data. We only share data with:</p>
            <ul>
              <li>Drivers (necessary ride details only)</li>
              <li>Payment processors</li>
              <li>Legal authorities when required by law</li>
              <li>Corporate clients (aggregated, anonymized data only)</li>
            </ul>

            <h2>4. Data Security</h2>
            <p>We implement industry-standard security measures including encryption, secure servers, and regular security audits to protect your information.</p>

            <h2>5. Your Rights</h2>
            <p>You have the right to:</p>
            <ul>
              <li>Access your personal data</li>
              <li>Correct inaccurate information</li>
              <li>Request deletion of your data</li>
              <li>Opt-out of marketing communications</li>
              <li>Export your data</li>
            </ul>

            <div className="legal-cta">
              <h3>Request Data Deletion</h3>
              <p>To request deletion of your account and associated data, please visit our <a href="/data-deletion">Data Deletion page</a> or contact info@mojexpress.com</p>
            </div>

            <h2>6. Contact Us</h2>
            <p>For privacy-related inquiries, contact our Data Protection Officer at:</p>
            <p>Email: info@mojexpress.com<br/>
            Address: Islamabad, Pakistan</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
